import { createContext, PropsWithChildren, ReactElement } from "react";
import { useAccount } from "@stores/session/hooks";
import { IAddon } from "./types";
import { addonsStore } from "./store";

export const AddOnsCatalogContext = createContext<IAddon[]>([]);

export function AddonsProvider({ children }: PropsWithChildren): ReactElement {
  const enabled = !!useAccount();
  const {
    isLoading,
    error,
    data: addons,
  } = addonsStore.useGetAddOns({
    enabled,
  });
  if (enabled && (isLoading || error || !addons)) {
    return <></>;
  }

  return (
    <AddOnsCatalogContext.Provider value={addons ?? []}>
      {children}
    </AddOnsCatalogContext.Provider>
  );
}
